<div class="panel panel-default">
  <div class="panel-heading flex flex--space-between">
    <h4 class="margin-top-0 margin-bottom-0 flex">
      <i *ngIf="currencySymbol !== 'CHF'" class="icon margin-right-8">money_notes_GBP</i>
      <small *ngIf="currencySymbol === 'CHF'" class="margin-right-8 chf-logo">CHF</small>
      {{ appCopy.panelHeader['extraBagPaymentTitle'+selectedLanguage] }}
    </h4>
  </div>
  <div class="panel-body" *ngIf="!adminBookingDetailsLoaded">
    <div class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  </div>
  <div class="panel-body" *ngIf="adminBookingDetailsLoaded">
    <p *ngIf="extraBagDoorstepPayment === null">{{ appCopy.panelHeader['noExtraBagPaymentsTakenText'+selectedLanguage] }}</p>
    <div *ngIf="extraBagDoorstepPayment !== null">
      <app-booking-details-door-step-display
        [appCopy]="appCopy"
        [selectedLanguage]= "selectedLanguage"
        [currencySymbol]="currencySymbol"
        [extraBagDoorstepPayment]="extraBagDoorstepPayment">
      </app-booking-details-door-step-display>
    </div>
    <a href="javascript:void(0);" *ngIf="extraBagDoorstepPayment !== null && extraBagDoorstepPayment.paymentStatus !== 2" (click)="redirectToSettings($event, 'extra-bag-payment')">{{ appCopy.panelHeader['takeExtraPaymentText'+selectedLanguage] }}</a>
  </div>
</div>
